import React from "react";
import { AutocompleteInput, ReferenceInput, TextInput } from "react-admin";

const filters = [
  <TextInput
    label="Име"
    source="filter"
    // sx={{ marginBottom: "1rem" }}
    resettable={true}
    alwaysOn
  />,
  <ReferenceInput
    reference={"applications-cms"}
    source="applicationId"
    queryOptions={{ meta: { mixed_provider: true } }}
    alwaysOn
  >
    <AutocompleteInput
      label="Application"
      filterToQuery={q => ({ Name: q })}
      optionText={"name"}
      fullWidth
    />
  </ReferenceInput>,
];
export default filters;
